export default __webpack_public_path__ + "static/media/generated-profile-pics.e870bfd3.png";